import { useGetPreviousPageSessionState } from "raci-react-library";
import { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { POLICY_CONFIRMATION_PAGE_URL, POLICY_PAYMENT_PAGE_URL } from "../routes.config";
import useRoutes from "../useRoutes";

export const ManuallyInitialisedPages: string[] = [];

export interface RouteGuardProps {
  disableChecks?: string[];
}

export const RouteGuard: React.FC<PropsWithChildren<RouteGuardProps>> = ({ disableChecks = [], children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { path: previousPageUrl, isCompleted: isPreviousPageCompleted } = useGetPreviousPageSessionState();
  const { isCompleted, lockdownPreviousPage } = useRoutes();

  /**
   * The below will check if the current page can
   * be navigated to by checking if the previous
   * page has been completed.
   */
  useEffect(() => {
    const currentLocation = location.pathname.toLowerCase();
    const bypass = disableChecks.filter((item) => item.toLowerCase() === currentLocation).length > 0;

    if (!bypass && previousPageUrl && !isPreviousPageCompleted && !lockdownPreviousPage) {
      navigate(previousPageUrl, { replace: true });
    }
  }, [navigate, disableChecks, previousPageUrl, isPreviousPageCompleted, location.pathname, lockdownPreviousPage]);

  /**
   * If user has completed their flow then transition to a different page (eg. quote or payment),
   */

  useEffect(() => {
    if (lockdownPreviousPage) {
      navigate(POLICY_PAYMENT_PAGE_URL, { replace: true });
    }
  }, [lockdownPreviousPage, navigate]);

  useEffect(() => {
    if (isCompleted) {
      navigate(POLICY_CONFIRMATION_PAGE_URL, { replace: true });
    }
  }, [navigate, isCompleted, lockdownPreviousPage]);

  useEffect(() => {
    try {
      const pageName = location.pathname.split("/").pop() ?? "";
      if (window.formotiv && !ManuallyInitialisedPages.includes(pageName)) {
        window.formotiv.init(window.formotivConfig);
      }
    } catch {}
  }, [location.pathname]);

  return <>{children}</>;
};

export default RouteGuard;
